import { HeaderText, HeaderSize } from '@/components/ui/HeaderText';
import { getPlayKitProductDescription } from '@/utils/productHelpers';

export interface AboutYourPlayKitProps {
  title: string;
  description: string | null | undefined;
}

function AboutYourPlayKit({ title, description }: AboutYourPlayKitProps) {
  const htmlString = description || '';
  const formattedDescription = getPlayKitProductDescription(htmlString);

  return (
    <div className="flex flex-col mb-6 md:mb-8">
      <HeaderText classes="mb-2" size={HeaderSize.H3} text={title} />
      {formattedDescription && (
        <p
          className="md:text-base text-sm"
          dangerouslySetInnerHTML={{ __html: formattedDescription }}
        />
      )}
    </div>
  );
}

export default AboutYourPlayKit;
